import { render, staticRenderFns } from "./TaxClassificationIcmsForm.vue?vue&type=template&id=50809e0a&"
import script from "./TaxClassificationIcmsForm.vue?vue&type=script&lang=js&"
export * from "./TaxClassificationIcmsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50809e0a')) {
      api.createRecord('50809e0a', component.options)
    } else {
      api.reload('50809e0a', component.options)
    }
    module.hot.accept("./TaxClassificationIcmsForm.vue?vue&type=template&id=50809e0a&", function () {
      api.rerender('50809e0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/invoice/parameters/components/TaxClassificationIcmsForm.vue"
export default component.exports